  import {AfterViewInit, Component, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
  import {environment} from "../../../../../environments/environment";
  import {MatPaginator} from "@angular/material/paginator";
  import {MatSort} from "@angular/material/sort";
  import {MatTableDataSource} from "@angular/material/table";
  import {Observable, Subject} from "rxjs";
  import {takeUntil} from "rxjs/operators";
  import {MatSelectChange} from "@angular/material/select";
  import {AngularFirestore} from "@angular/fire/compat/firestore";
  import {MatDialog} from "@angular/material/dialog";
  import {AddChildCaseStudyComponent} from "./add-child-case-study/add-child-case-study.component";
  import {Centre} from "../../../../interfaces/Centres";
  import {FullChild} from "../../../../interfaces/FullChild";
  import {CentreService} from "../../../../services/centre.service";
  import {ChildService} from "../../../../components/child/child.service";
  import {Router} from "@angular/router";
  import {needConfirmation} from "../../../../confirm-dialog/confirm-dialog.decorator";
  import {MatSnackBar} from "@angular/material/snack-bar";
  import {PermissionType} from "../../../../components/employee/PermissionType.enum";
  import {LogService} from "../../../../services/log.service";
  import * as XLSX from "xlsx";



  @Component({
    selector: 'app-child-case-study',
    templateUrl: './child-case-study.component.html',
    styleUrls: ['./child-case-study.component.scss']
  })
  export class ChildCaseStudyComponent implements OnInit, OnDestroy, AfterViewInit {
    env = isDevMode() ? environment.testMode : environment.productionMode;
    private readonly _destroyed$ = new Subject<void>();
    displayedColumns: String[] = ['position', 'centreName','firstName', 'lastName', 'doa', 'city', 'state', 'hospitalname', 'Action'];
    @ViewChild(MatPaginator) paginator1!: MatPaginator;
    @ViewChild(MatSort) sort1!: MatSort;
    dataSource!: MatTableDataSource<any>;
    centres$!: Observable<Centre[]>;
    mSelectedCentre: any;
    mChildren!: FullChild[];
    selectedChildData: any;
    selectedChild: any;
    children$?: Observable<FullChild[]>

    constructor(private readonly mCentreService: CentreService,
                private readonly mChildService: ChildService,
                private readonly mFirestore: AngularFirestore,
                private readonly matDialog:MatDialog,
                private mSnackbar:MatSnackBar,
                private mLogService:LogService,
                private  readonly childService: ChildService,
                private mRouter:Router) {
      this.centres$ = this.mCentreService.getAllCentres()

    }

    ngOnInit(): void {
      this.loadListData();
    }

    ngAfterViewInit(): void {
      if (this.dataSource) this.dataSource.sort = this.sort1;
    }

    private configureDataSource(data: any[]) {
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.sortingDataAccessor = (item, property) => {
        if (property === 'doa') return item.date?.toDate?.().getTime() ?? 0;
        if (property === 'happyDischargeDate') return item.dischargeDate?.toDate?.().getTime() ?? 0;
        return item[property];
      };
      this.dataSource.paginator = this.paginator1;
      this.dataSource.sort = this.sort1;
    }

    loadListData(){
      this.mFirestore.collection(this.env.childCaseStudy).valueChanges({idField: 'id'})
        .pipe(takeUntil(this._destroyed$))
        .subscribe(data => {
          this.configureDataSource(data);
          console.log(data)
        });
    }

    onCentreSelected2($event: MatSelectChange) {
      this.mSelectedCentre = $event.value
      this.mChildService.getAlloteCaseStudydChildListByCenter(this.mSelectedCentre)
        .pipe(takeUntil(this._destroyed$))
        .subscribe(res => this.mChildren = res.filter(child => child.reason !== 'OM SHANTI')
        )
    }
    onCentreSelected($event: MatSelectChange): void {
      this.mChildren = [];
      this.mSelectedCentre = $event.value;
      this.children$ = this.childService.getAlloteCaseStudydChildListByCenter(this.mSelectedCentre);
      this.children$.pipe(takeUntil(this._destroyed$)).subscribe(res => {
        // Add allotted children (already filtered for age >= 3)
        const allottedChildren = [...res];
        // Fetch and add discharged children
        this.childService.getDischargedChildListByCenterAboveThreeWithinThreeDaysEducation(this.mSelectedCentre)
          .then(dischargedRes => {
            const dischargedChildren = dischargedRes.docs
              .map(x => x.data() as FullChild)
              .filter(child => child.age >= 3); // Filter once

            console.log('DISCHARGED CHILDREN IN SELECT', dischargedChildren.length);

            // Combine all children and deduplicate by childCode
            const allChildren = [...allottedChildren, ...dischargedChildren];

            // Use Map to deduplicate based on childCode
            const uniqueChildrenMap = new Map<string, FullChild>();
            allChildren.forEach(child => {
              const key = child.childCode || child.id || `${child.firstName}_${child.lastName}`;
              if (!uniqueChildrenMap.has(key)) {
                uniqueChildrenMap.set(key, child);
              }
            });

            // Convert Map back to array and sort
            this.mChildren = Array.from(uniqueChildrenMap.values())
              .sort((a, b) =>
                a.firstName.localeCompare(b.firstName) ||
                a.lastName.localeCompare(b.lastName)
              );

            console.log(`Total unique children: ${this.mChildren.length}`);
          })
          .catch(error => {
            console.error('Error fetching discharged children:', error);
          });
      });
    }

    applyFilter($event: Event) {
      const filterValue = ($event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim();

      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }
    clearAll() {
      this.mSelectedCentre = '';
      this.selectedChildData = '';
      this.selectedChild = '';

      this.mChildren = []; // clear child dropdown list

      // Reload full table data again
      this.loadListData();

      // Optional: reset filter input if exists
      if (this.dataSource?.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }

    downloadExcel() {
      if (!this.dataSource || !this.dataSource.data || this.dataSource.data.length === 0) {
        this.mSnackbar.open('No data available to download', 'Close', {
          duration: 2000
        });
        return;
      }

      const exportData = this.dataSource.data.map((item: any, index: number) => ({
        'Sr No': index + 1,
        'Centre Name': item.centreName || '',
        'First Name': item.firstName || '',
        'Last Name': item.lastName || '',
        'Date Of Admission': item.date
          ? item.date.toDate().toLocaleDateString()
          : '',
        'Happy Discharge Date': item.dischargeDate
          ? item.dischargeDate.toDate().toLocaleDateString()
          : 'NA',
        'City': item.city || '',
        'State': item.state || '',
        'Hospital': item.hospital || ''
      }));

      // Create worksheet & workbook
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Child Case Study');

      // Download file
      XLSX.writeFile(workbook, 'AL_Child_Case_Study.xlsx');

      //  Activity Log (same pattern as rest of module)
      const activity = {
        date: new Date().getTime(),
        section: 'Child Case Study',
        action: 'Download',
        description: 'Child Case Study list downloaded as Excel',
        currentIp: localStorage.getItem('currentip')!
      };
      this.mLogService.addLog(activity);

      this.mSnackbar.open('Excel downloaded successfully', 'Close', {
        duration: 2000
      });
    }



    onChildSelect($event: MatSelectChange) {
      this.selectedChild = $event.value.id
    }

    searchChildByCode() {
      const selectedCentreCode = this.mSelectedCentre;  // e.g., "AL Mumbai"
      const selectedChildCode = this.selectedChildData?.childCode; // e.g., "CH12345"
      const selectedChild = this.selectedChildData; // e.g., "CH12345"
      this.mFirestore.collection(this.env.childCaseStudy).valueChanges({ idField: 'id' })
        .pipe(takeUntil(this._destroyed$))
        .subscribe((data: any[]) => {
          let filteredData = data;
          // Filter by center (if selected)
          if (selectedCentreCode) {
            filteredData = filteredData.filter(child => child.centreName === selectedChild.centreName);
          }
          // Filter by child (if selected)
          if (selectedChildCode) {
            filteredData = filteredData.filter(child => child.childCode === selectedChildCode);
          }
          this.configureDataSource(filteredData);
        });
    }




    addCaseStudyReport() {
      this.mRouter.navigateByUrl('home/reports/Add-child-case-study')
    }


    ViewReportChildCaseStudy(id: any) {
      // this.mRouter.navigateByUrl('home/reports/view-child-case-study')
      this.mRouter.navigate(['home/reports/view-child-case-study', id]);
    }




    editReport(id:string) {
      this.mRouter.navigate(['home/reports/Add-child-case-study',id])
    }


    @needConfirmation()
    deleteReport(id:string) {
      this.mFirestore.collection(this.env.childCaseStudy).doc(id).delete().then(()=>{
        // ⭐ LOG
        const activity = {
          date: new Date().getTime(),
          section: 'Child Case Study',
          action: 'Delete',
          description: `Deleted case study with ID: ${id}`,
          currentIp: localStorage.getItem('currentip')!
        };
        this.mLogService.addLog(activity);

        this.mSnackbar.open('Deleted', '', {
          panelClass: 'success-snackbar',
          duration: 3000
        });

      })
    }

      protected readonly PermissionType = PermissionType;

      ngOnDestroy(): void {
        this._destroyed$.next();
        this._destroyed$.complete();
      }
  }
